module.exports = __webpack_public_path__ + "img/reward-cloud-header.34c2bdba.png";